@if (pfTitle) {
    <pf-text type="description">{{ pfTitle }}</pf-text>
}
<nz-segmented
    [nzOptions]="segmentedOptions | safeAny"
    [(ngModel)]="model"
    (ngModelChange)="handleModelChange($event)"></nz-segmented>
